import React, { useEffect, useCallback, memo } from 'react'
import { AnimatePresence, m as motion } from 'framer-motion'
import { useRecoilState, useRecoilValue } from 'recoil'
import { siteSections as siteSectionsState, siteData as siteDataState } from '../../store/dataStore'
import {
  toggleMenu as toggleMenuState,
  selectedClients as selectedClientsState,
  currentSection as currentSectionState,
  currentFix as currentFixState,
  lastSection as lastSectionState,
} from '../../store/uiStore'
import { MainNavigation, Menu } from '../../styles/headerStyles'
import Social from '../Social'
import Background from './Background'
import {Globe} from '../../assets/svg/icons'

const SideMenu = memo(
  React.forwardRef((props, ref) => {
    const [toggleMenu, setToggleMenu] = useRecoilState(toggleMenuState)

    const { language } = useRecoilValue(siteDataState)

    const menuLinksData = useRecoilValue(siteSectionsState).slice(1)

    const [currentSection, setCurrentSection] = useRecoilState(
      currentSectionState
    )
    const [selectedClients, setSelectedClients] = useRecoilState(
      selectedClientsState
    )
    const [currentFix, setCurrentFix] = useRecoilState(
      currentFixState
    )
    const [lastSection, setLastSection] = useRecoilState(
      lastSectionState
    )

    const ulVariants = {
      hidden: {
        opacity: 0,
        transition: {
          ease: 'linear',
          delayChildren: 0,
        },
      },
      visible: {
        opacity: 1,
        transition: {
          ease: 'linear',
          staggerChildren: 0.3,
          delayChildren: 0.5,
        },
      },
    }
    const childVariants = {
      hidden: {
        y: '100%',
        opacity: 0,
      },
      visible: {
        y: 0,
        opacity: 1,
      },
    }

    const handleNavClick = useCallback(
      (section) => {
        if (currentFix !== section) {
          if (section === 'clientes' || section === 'aliados') {
            setCurrentSection((last) => 'clientes')
            setSelectedClients((last) => section === 'clientes' ? 0 : 1)
          } else {
            setCurrentSection((last) => section)
          }
          setLastSection((last) => currentFix)
          setCurrentFix((last) => section)
        }
        setToggleMenu((last) => false)
      },
      /* eslint-disable-next-line react-hooks/exhaustive-deps */
      [lastSection]
    )

    useEffect(() => {
      if ( currentSection === 'clientes' ) {
        setCurrentFix((last) => selectedClients === 0 ? currentSection : 'aliados')
      } else {
        setCurrentFix((last) => currentSection)
      }
      /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [lastSection])

    return (
      <AnimatePresence exitBeforeEnter>
        {toggleMenu && (
          <MainNavigation
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{
              opacity: 0,
              transition: {
                duration: 0.5,
                delay: 0.75,
                ease: 'linear',
              },
            }}
            transition={{ duration: 1, ease: 'easeOut' }}>
            <Background />
            <Menu
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{
                opacity: 0,
                transition: {
                  duration: 0.5,
                  ease: 'linear',
                },
              }}
              transition={{
                duration: 0.3,
              }}>
              <motion.ul
                variants={ulVariants}
                initial='hidden'
                animate='visible'>
                {menuLinksData.map((item, index) => (
                  <motion.li
                    key={`side-nav-menu-item-${item.slug}-${index}`}
                    variants={childVariants}
                    transition={{
                      duration: 0.75,
                      ease: 'easeOut',
                    }}>
                    <button
                      className={currentFix === item.slug ? 'active' : ''}
                      onClick={() => handleNavClick(item.slug)}>
                      <span>{item.link}</span>
                    </button>
                  </motion.li>
                ))}
              </motion.ul>
            </Menu>
            <Social isSideMenu />
            <motion.a
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{
                opacity: 0,
                transition: {
                  duration: 0.3,
                  delay: 0,
                  ease: 'linear',
                },
              }}
              transition={{ duration: 1, ease: 'easeOut', delay: 1.25 }}
              href={`${language === 'en' ? '/es' : '/en'}`}
              className="language"
            >
            <span><Globe /></span>
            { language === 'en' ? 'Español' : 'English' }
            </motion.a>
          </MainNavigation>
        )}
      </AnimatePresence>
    )
  })
)

export default SideMenu
